import { useEffect, useState } from "react";
import {
  ButtonNext,
  ButtonSendAgain,
  ContainerButtons,
  ContainerIcons,
  ContainerModel,
  ContainerStatusEmailDone,
  ContainerStatusEmailUnDone,
  ContainerValidLink,
  ContentContainerModel,
  DescribeMessage,
  MessageConfirm,
  TextTimer,
  TitleModel,
} from "./ConfirmEmailStyle.styled";
import { IconDone, UnConfirmEmailIcon } from "./Icons/Icons";
import {
  ResendConfirmEmailUser,
  StatusEmailUser,
} from "../../../../API/ConfirmEmailUser/ConfirmEmailUser";
import useAuth from "../../../../Redux/useAuth";
import { useLanguageContext } from "../../../Languages/Langs/LanguageContext";

interface ConfirmEmailModelProps {
  onNext: () => void;
}

export const ConfirmEmailModel: React.FC<ConfirmEmailModelProps> = ({
  onNext,
}) => {
  const { idUser } = useAuth();
  const { t } = useLanguageContext();
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [isEmailConfirmed, setIsEmailConfirmed] = useState<boolean | null>(
    null,
  );

  // ✅ Polling для перевірки статусу email
  useEffect(() => {
    if (!idUser) return;

    const fetchEmailStatus = async () => {
      try {
        const verified = await StatusEmailUser(idUser);
        setIsEmailConfirmed(verified);
      } catch (error) {
        console.error(error);
      }
    };

    // перший запит тільки один раз
    fetchEmailStatus();
  }, [idUser]);

  useEffect(() => {
    setIsTimerRunning(true);
  }, []);

  // ✅ Повторне надсилання листа
  const handleResendEmail = async () => {
    try {
      await ResendConfirmEmailUser(idUser || "");
    } catch (error) {
      console.error(error);
    }
  };

  const filled = !!isEmailConfirmed;

  return (
    <ContainerModel>
      <ContentContainerModel>
        <TitleModel>{t("privateTraslate.Models.ConfirmEmailTitle")}</TitleModel>

        <DescribeMessage>
          {t("privateTraslate.Models.ConfirmEmailDescribeMessage")}
        </DescribeMessage>
        <MessageConfirm>
          {t("privateTraslate.Models.ConfirmEmailMessageConfirm")}
        </MessageConfirm>

        <ContainerValidLink>
          <TextTimer>
            {isEmailConfirmed
              ? t("privateTraslate.Models.ConfirmEmailConfirmedTextStatus")
              : t("privateTraslate.Models.ConfirmButtonSendAgainLetterStatus")}
          </TextTimer>
        </ContainerValidLink>

        {isEmailConfirmed ? (
          <ContainerIcons>
            <ContainerStatusEmailDone>
              <IconDone />
            </ContainerStatusEmailDone>
          </ContainerIcons>
        ) : (
          <ContainerIcons>
            <ContainerStatusEmailUnDone>
              <UnConfirmEmailIcon />
            </ContainerStatusEmailUnDone>
          </ContainerIcons>
        )}

        <ContainerButtons>
          <ButtonNext
            $filled={filled}
            disabled={!isEmailConfirmed}
            onClick={onNext}
          >
            {t("privateTraslate.Models.ConfirmEmailButtonNext")}
          </ButtonNext>

          <ButtonSendAgain
            type="button"
            // $filled={!!isEmailConfirmed}
            onClick={handleResendEmail}
            // disabled={isTimerRunning || !!isEmailConfirmed}
          >
            {isTimerRunning
              ? t("privateTraslate.Models.ConfirmButtonSendAgainLetterStatus")
              : t("privateTraslate.Models.ConfirmButtonSendAgainWait")}
          </ButtonSendAgain>
        </ContainerButtons>
      </ContentContainerModel>
    </ContainerModel>
  );
};
